import { LOCATION_PLACE_TYPE } from 'types/services';
import { NudosTextInput } from '../../../../../../components/NudosComponents';

const LogisticServiceNudosLocation = ({
  place,
  countryName
}: {
  place?: string | null;
  countryName?: string | null;
}) => {
  const noDataText = 'Sin datos';
  const getLocationName = () => {
    if (
      [LOCATION_PLACE_TYPE.NUDOS, LOCATION_PLACE_TYPE.DIAGNOSTIC, LOCATION_PLACE_TYPE.WARRANTY].includes(
        place as LOCATION_PLACE_TYPE
      )
    )
      return 'Bodegas';
    return noDataText;
  };

  return (
    <div className="LogisticServiceNudosLocation">
      <div className="fieldsContent">
        <NudosTextInput
          componentSize="small"
          label="Ubicacion"
          placeholder={getLocationName()}
          defaultValue={getLocationName()}
          isFilled={true}
          isDeactivated
        />
        <NudosTextInput
          componentSize="small"
          label="Pais"
          placeholder={countryName || noDataText}
          defaultValue={countryName || noDataText}
          isFilled={true}
          isDeactivated
        />
      </div>
    </div>
  );
};

export default LogisticServiceNudosLocation;
